import React from 'react';
import {load} from 'recaptcha-v3';

import LoadingDots from './loadingdots';

export class ContactForm extends React.Component {
    static title = "Contact Form";
    static category = 'layout';
    static icon = 'email-alt';

    constructor() {
        super(...arguments);

        this.state = {
            token: null,
            loading: true,
            submitted: false,
            success: false,
            errorMessages: [],
            firstName: null,
            lastName: null,
            email: null,
            message: null
        };

        this.onJSON = this.onJSON.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onToken = this.onToken.bind(this);
        this.loadToken = this.loadToken.bind(this);

        this.loadToken();
    }

    setter(key) {
        return e => {
            let v = e.target.value;
            this.setState(st => ({...st, [key]: v}));
        };
    }

    loadToken() {
        if (!this.props.gutenberg.isEditor) {
            load(polyphony.getState().recaptcha.site_key, {autoHideBadge: true})
                .then(r => r.execute('contact'))
                .then(this.onToken);
        }
    }

    onToken(token) {
        this.setState(st => ({...st, loading: false, token}));
    }

    onJSON({success}) {
        let addon = success ? {firstName: null, lastName: null, email: null, message: null} : {};
        this.setState(st => ({...st, ...addon, errorMessages: [], submitted: true, success, loading: false}), this.loadToken);
    }

    onSubmit() {
        function validateEmail(email) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        }

        const isInvalid = v => !v || v.length === 0;

        const {firstName, lastName, email, message, token} = this.state;

        let errorMessages = [];
        if (isInvalid(firstName)) {
            errorMessages.push('First Name is a required field.');
        }

        if (isInvalid(lastName)) {
            errorMessages.push('Last Name is a required field.');
        }

        if (isInvalid(email)) {
            errorMessages.push('Email is a required field.');
        } else if (!validateEmail(email)) {
            errorMessages.push('Invalid email address.');
        }

        if (errorMessages.length === 0) {
            this.setState(st => ({...st, loading: true}));
            fetch("/?" + polyphony.util.joinURIComponents({
                rest_route: '/polyphony-child/v1/contact',
                first_name: firstName,
                last_name: lastName,
                email: email,
                message: message,
                google_site_token: token
            }), {
                method: 'POST'
            }).then(x => x.json()).then(this.onJSON);
        } else {
            this.setState(st => ({...st, errorMessages}));
        }
    }

    render() {
        if (this.props.gutenberg.isEditor) {
            return <div>Contact Form</div>;
        }

        const {submitted, success, loading, errorMessages} = this.state;

        let greenMessages = [];
        let redMessages = [...errorMessages];

        if (loading) {
            return <div className='pc-contact-form pc-contact-form-loading'><LoadingDots dotStyle={{background: 'black'}} /></div>;
        }

        if (submitted) {
            const {success_message, failure_message} = polyphony.getState().recaptcha;
            if (success) greenMessages.push(success_message);
            else         redMessages.push(failure_message);
        }

        return (
            <div className="pc-contact-form">
                {greenMessages.length > 0 && <div className='pc-contact-form-greenbox'>
                    {greenMessages.map(m => <span>{m}</span>)}
                </div>}
                {redMessages.length > 0 && <div className='pc-contact-form-redbox'>
                    {redMessages.map(m => <span>{m}</span>)}
                </div>}
                <span>First Name</span>
                <input onChange={this.setter('firstName')} value={this.state.firstName} required />
                <span>Last Name</span>
                <input onChange={this.setter('lastName')} value={this.state.lastName} required />
                <span>Email</span>
                <input onChange={this.setter('email')} value={this.state.email} required />
                <span>Message</span>
                <textarea onChange={this.setter('message')} value={this.state.message} required />
                <div className="captcha-text">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noreferer nofollow">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="nofollow">Terms of Service</a> apply.</div>
                <div className='submit-container'><div className='submit-button' onClick={this.onSubmit}>Submit</div></div>
            </div>
        );
    }
}

export default ContactForm;
